import React from 'react';
import { Gift, Sparkles, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../../context/SiteSettingsContext';

const PromoBanner = ({ variant = 'default' }) => {
  const { settings } = useSiteSettings();
  const promotion = settings.promotion || {};
  const trialMonths = promotion.trialMonths || 2;
  const isEnabled = promotion.enabled !== false;
  const bannerEnabled = promotion.bannerEnabled !== false;
  
  // Don't render if promotion is disabled
  if (!isEnabled) return null;
  
  const promoText = `🎉 OFFRE DE LANCEMENT : ${trialMonths} MOIS OFFERTS pour les vétérinaires ! Inscription gratuite, premier prélèvement dans ${trialMonths} mois.`;
  
  // Scrolling banner for homepage
  if (variant === 'scrolling') {
    if (!bannerEnabled) return null;
    
    return (
      <div className="bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-400 text-white py-2 overflow-hidden">
        <div className="animate-marquee whitespace-nowrap flex items-center">
          {[...Array(4)].map((_, i) => (
            <span key={i} className="mx-8 flex items-center gap-2 text-sm font-medium">
              <Sparkles className="w-4 h-4" />
              {promoText}
              <Link to="/espace-veterinaire" className="underline hover:no-underline ml-2 flex items-center gap-1">
                En profiter <ArrowRight className="w-3 h-3" />
              </Link>
            </span>
          ))}
        </div>
      </div>
    );
  }

  // Highlighted banner for vet page
  if (variant === 'highlighted') {
    return (
      <div className="bg-gradient-to-r from-orange-500 to-yellow-400 rounded-2xl p-6 text-white shadow-xl shadow-orange-500/20 mb-8">
        <div className="flex flex-col md:flex-row items-center gap-4">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
            <Gift className="w-8 h-8" />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-xl font-bold mb-1">🎉 Offre de lancement exclusive !</h3>
            <p className="text-orange-100">
              <strong>{trialMonths} mois offerts</strong> pour découvrir vetoRDV. Votre carte bancaire est enregistrée à l'inscription, 
              mais le <strong>premier prélèvement n'intervient qu'après {trialMonths} mois</strong>. Annulez à tout moment !
            </p>
          </div>
          <div className="flex-shrink-0">
            <span className="inline-block px-4 py-2 bg-white text-orange-500 rounded-full font-bold text-lg">
              {trialMonths} MOIS GRATUITS
            </span>
          </div>
        </div>
      </div>
    );
  }

  // Card variant for signup section
  if (variant === 'card') {
    return (
      <div className="border-2 border-orange-400 bg-orange-50 dark:bg-orange-900/20 rounded-xl p-4 mb-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-orange-400 rounded-full flex items-center justify-center flex-shrink-0">
            <Gift className="w-5 h-5 text-white" />
          </div>
          <div>
            <h4 className="font-bold text-orange-600 dark:text-orange-400 mb-1">
              🎁 {trialMonths} mois offerts !
            </h4>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Testez vetoRDV gratuitement pendant {trialMonths} mois. Carte bancaire requise à l'inscription, 
              premier prélèvement dans {trialMonths * 30} jours.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Compact inline variant
  if (variant === 'inline') {
    return (
      <div className="flex items-center gap-2 text-orange-500 dark:text-orange-400 text-sm font-medium">
        <Gift className="w-4 h-4" />
        <span>{trialMonths} mois offerts - Premier prélèvement dans {trialMonths * 30} jours</span>
      </div>
    );
  }

  // Default - small badge
  return (
    <span className="inline-flex items-center gap-1 px-3 py-1 bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 rounded-full text-xs font-medium">
      <Gift className="w-3 h-3" />
      {trialMonths} mois offerts
    </span>
  );
};

export default PromoBanner;
